

export function applyFilters( data, filters, reportConfig ) {
    return data.filter( ( item ) => {
        // Handle date filtering
        const dateFields = reportConfig.dateFields || [ 'createdDate' ];
        if ( filters.dateRange !== 'all' ) {
            const [ start, end ] = getDateRange( filters );
            filters.startDate = start;
            filters.endDate = end;

            const hasValidDate = dateFields.some( ( field ) => {
                const itemDate = item[field] ? new Date( item[field] ) : null;
                return itemDate && itemDate >= start && itemDate <= end;
            } );
          
            if ( !hasValidDate ) {
                return false;
            }
        }

        // Loan Purpose
        if ( filters.loanPurpose.length > 0 && !filters.loanPurpose.includes( item.purpose ) ) {
            return false;
        }

        // Loan Type
        if ( filters.loanType.length > 0 && !filters.loanType.includes( item.loanType ) ) {
            return false;
        }

        // Loan Source
        if ( filters.loanSource.length > 0 && !filters.loanSource.includes( item.loanSource ) ) {
            return false;
        }

        // Referral Source
        if ( filters.referralSource.length > 0 && !filters.referralSource.includes( item.referralSource ) ) {
            return false;
        }

        // State
        if ( filters.state.length > 0 && !filters.state.includes( item.subjectState ) ) {
            return false;
        }

        // County
        if ( filters.county.length > 0 && !filters.county.includes( item.subjectCounty?.trim().toLowerCase() ) ) {
            return false;
        }

        // City
        if ( filters.city.length > 0 && !filters.city.includes( item.subjectCity?.trim().toLowerCase() ) ) {
            return false;
        }

        // Zip
        if ( filters.zip.length > 0 && !filters.zip.includes( item.subjectZip ) ) {
            return false;
        }

        // Purchase Price min/max
        const pp = normalizeNumber( item.purchasePrice );
        let minSet = filters.minPurchasePrice !== null && filters.minPurchasePrice !== '';
        let maxSet = filters.maxPurchasePrice !== null && filters.maxPurchasePrice !== '';

        if ( minSet && pp === null ) return false;
        if ( maxSet && pp === null && minSet ) return false; // exclude if both set

        if ( minSet && pp < filters.minPurchasePrice ) return false;
        if ( maxSet && pp > filters.maxPurchasePrice ) return false;

        // Loan Amount min/max
        const loanAmount = normalizeNumber( item.amount );
        minSet = filters.minLoanAmount !== null && filters.minLoanAmount !== '';
        maxSet = filters.maxLoanAmount !== null && filters.maxLoanAmount !== '';

        if ( minSet && loanAmount === null ) return false;
        if ( maxSet && loanAmount === null && minSet ) return false; // exclude if both set

        if ( minSet && loanAmount < filters.minLoanAmount ) return false;
        if ( maxSet && loanAmount > filters.maxLoanAmount ) return false;

        // Interest rate (min/max)
        const rate = normalizeRate( item.rate );
        const minRateSet = filters.minInterestRate !== null && filters.minInterestRate !== '';
        const maxRateSet = filters.maxInterestRate !== null && filters.maxInterestRate !== '';

        if ( minRateSet && rate === null ) return false;
        if ( maxRateSet && rate === null && minRateSet ) return false;
        if ( minRateSet && rate < filters.minInterestRate ) return false;
        if ( maxRateSet && rate > filters.maxInterestRate ) return false;
        
        return true;
    } );
}

function getDateRange( filters ) {
    const now = new Date();
    let start, end;
  
    switch ( filters.dateRange ) {
      case 'last30days':
        start = new Date(now);
        start.setDate(now.getDate() - 30);
        end = new Date();
        break;
  
      case 'last90days':
        start = new Date(now);
        start.setDate(now.getDate() - 90);
        end = new Date();
        break;
  
      case 'last180days':
        start = new Date(now);
        start.setDate(now.getDate() - 180);
        end = new Date();
        break;
  
      case 'ytd':
        start = new Date(now.getFullYear(), 0, 1); // Jan 1 of this year
        end = new Date();
        break;
  
      case 'custom':
        start = filters.startDate ? new Date(filters.startDate) : null;
        end = filters.endDate ? new Date(filters.endDate) : null;
        break;
  
      default:
        start = null;
        end = null;
        break;
    }
  
    return [ start, end ];
}

function normalizeNumber( value ) {
    if ( value === null || value === undefined ) return null;
  
    if ( typeof value === 'number' ) return value;
  
    if ( typeof value === 'string' ) {
        const cleaned = value.replace( /[$,]/g, '' ).trim();
        const num = parseFloat( cleaned );
        return isNaN( num ) ? null : num;
    }
  
    return null;
}

function normalizeRate( value ) {
    if ( value === null || value === undefined ) return null;
  
    let num;
  
    if ( typeof value === 'number' ) {
        num = value;
    } else if ( typeof value === 'string' ) {
        const cleaned = value.replace( /[%]/g, '' ).trim();
        num = parseFloat( cleaned );
    } else {
        return null;
    }
  
    if ( isNaN( num ) ) return null;
  
    // If it's ≤ 1, assume it's a decimal fraction (e.g., 0.0625) → convert to percent
    if ( num <= 1 ) num = num * 100;
  
    return num;
}
  